import { DataRoomRecipientEligibility } from 'shared';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { AccessRole } from '../../types/stakeholder.types';
import { useAppQuery } from '../use-app-query.hook';
import { useSelectedCompany } from '../use-selected-company.hook';

export type RecipientEligibility = {
  eligibility: DataRoomRecipientEligibility;
  guestRole: AccessRole | null;
};

/**
 * What the External Recipients field may do with a typed address — 20.4.1 section 5.
 *
 * Its own route rather than the candidate list: that list deliberately hides Guest Contributors
 * and Auditors, and these are exactly the people the field has to recognise and refuse.
 */
export const useRecipientEligibility = (
  id: string | undefined,
  email: string,
  { enabled = true }: { enabled?: boolean } = {},
) => {
  const { selectedCompany } = useSelectedCompany();
  const companyId = selectedCompany?.id ?? '';

  const { data, isLoading } = useAppQuery({
    enabled: enabled && Boolean(companyId && id && email),
    queryFn: () =>
      ApiService.get<RecipientEligibility>(
        {
          endpoint: BackendRoute.DATA_ROOMS,
          routePath: [id ?? '', 'share-candidates', 'eligibility'],
        },
        { queryParams: { email } },
      ),
    queryKey: [QueryKey.DATA_ROOM_RECIPIENT_ELIGIBILITY, companyId, id, email],
  });

  return { eligibility: data, isLoading };
};
